import React, { Component } from 'react'
import _ from 'lodash';


export default class DisableNextModal extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  render() {
    
    
    return (
        <div className='opacity-overlay ' style={{'display': 'block'}}>
            <div className="container">
                <div className="popup-wrapper">
                    <div className="col-xs-12 col-sm-4 popup-content">
                        { this.props.disableNextState &&
                            <div>
                                <div className='modal-header'>
                                    <h5>{this.props.disableModalTitle}</h5>
                                </div>
                                <div className='modal-body'>
                                    <p>{this.props.disableModalText}</p>
                                    
                                    <div 
                                        onClick={this.props.disableNextModal} 
                                        className="btn btn-cancel">
                                            Ok
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/Common/disableNextModal.jsx